import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import Admin from "./pages/Admin";
import ProductDetail from "./pages/ProductDetail";
import { Toaster } from "./components/ui/toaster";
import { FloatingWhatsApp } from "./components/FloatingWhatsApp";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <FloatingWhatsApp />
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
